import * as React from 'react';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 'auto',
    },
  },
};
export default (props) => {
  const {
    id,
    className,
    autoFocus,
    disabled,
    value,
    options,
    onFocus,
    onChange,
    onKeyDown,
  } = props;
  const handleValue = (val) => {
    if (val === null || val === '-1') {
      return '';
    }
    return val;
  };
  return (
    <div>
      <FormControl
        sx={{ m: 1, minWidth: 107 }}
        disabled={disabled}
        onKeyDown={(e) => {
          if (onKeyDown) {
            onKeyDown(e);
          }
        }}
      >
        <Select
          labelId="demo-multiple-chip-label"
          id={id}
          className={className}
          autoFocus={autoFocus}
          autoWidth
          value={handleValue(value)}
          onChange={(e) => {
            onChange(e?.target);
          }}
          onFocus={() => {
            if (onFocus) {
              onFocus();
            }
          }}
          input={<OutlinedInput id="select-multiple-chip" label="" />}
          renderValue={(selected) => (
            <Box>
              <Chip key={selected} label={selected} />
            </Box>
          )}
          MenuProps={MenuProps}
        >
          <MenuItem key="" value="" className="frr-dropdown-blank-item" />
          {options?.map((item) => (
            <MenuItem key={item?.label} value={item?.value}>
              {item?.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};
